/**
 * Route admin `/tutor/admin/animations/lab` — banc du lecteur d'animations
 * (moteur JRAF ; cf. docs/animations/PLAN_MOTEUR_ANIMATIONS.md).
 *
 * Joue l'animation de référence (`@jeraisonne/animation`, fixture Pythagore)
 * comme un élève, avec ou sans accès à la partie interactive.
 */

import { useMemo } from 'react';
import fixture from '@jeraisonne/animation/fixtures/pythagore.jraf.json';
import { validateJraf } from '@jeraisonne/animation';
import { AnimationIssues, AnimationTestBench } from '@/features/animations/animation-test-bench';
import { TOOL_IDS } from '@/features/toolbox/catalog';

export function TutorAdminAnimationLabPage() {
  const result = useMemo(() => validateJraf(fixture, { toolIds: TOOL_IDS }), []);
  return (
    <div className="mx-auto max-w-3xl p-4 sm:p-6">
      <div className="mb-3">
        <h1 className="font-display text-ink-900 text-[22px] font-extrabold">Animations — banc</h1>
        <p className="text-ink-500 mt-0.5 text-[13px]">
          Animation de référence, jouée comme un élève.
          {result.ok ? ` Lecteur ${result.runtimeMin}.` : ''}
        </p>
      </div>
      {result.ok ? (
        <AnimationTestBench doc={result.doc} />
      ) : (
        <AnimationIssues errors={result.errors} warnings={result.warnings} />
      )}
    </div>
  );
}
